import common from "@/utils";
export default {
  data() {
    return {
      shouldFixedAtBottomWhenScroll: true, // 左侧菜单栏当滚动到底部的时候是否应该固定在底部【防止左侧菜单栏无数据只有筛选条件的时候，菜单栏滚动到底部依然固定造成的样式问题】【在使用的组件中进行赋值覆盖，以控制这一效果】
      maxScrollTopBeforeFixed: 0, // 左侧悬浮菜单在悬浮前，页面可滚动的最大距离【当滚动到这个距离后进行悬浮】
      leftMenuFixed: false, // 左侧菜单是否悬浮
      fixedLeft: 0, // 左侧菜单悬浮时left值
      moduleTops: [], // 各个模块距离页面顶部的距离
      // menus: null, // 左侧悬浮菜单
      activeMenuIndex: -1, // 高亮菜单下标
      triggerScrolling: false, // 通过点击左侧菜单栏触发的滚动
      maxScrollTopAfterFixed: 0, // 左侧悬浮菜单悬浮后，页面能滚动的最大距离
      leftMenuAbsoluteBottom: false, // 左侧悬浮菜单定位在父容器底部
      footerAndConnectHeight: 0, // 底部组件加“用心连接，U+服务”的总高度
      mainContent: null,
      triggerTimer: null,
      imgsCountInContent: 0, // 主内容中的图片数量
      imgLoadedCount: 0 // 已加载完成的图片数量
    };
  },
  computed: {
    suspensionStyle() {
      return this.leftMenuAbsoluteBottom
        ? {
            position: "absolute",
            top: "initial",
            bottom: "0px"
          }
        : {
            position: this.leftMenuFixed ? "fixed" : "absolute",
            left: this.leftMenuFixed ? this.fixedLeft + "px" : "0px",
            // top: this.leftMenuFixed ? "60px" : "0px",
            top: "0px",
            bottom: "initial"
          };
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(() => {
      this.mainContent = this.$refs.mainContent;
      if (this.mainContent) {
        this.genLeftValueOfMenu();
        this.maxScrollTopBeforeFixed = getTrueTop(this.mainContent);
        window.addEventListener("scroll", this.throttleHandle);
        window.addEventListener("resize", this.genLeftValueOfMenu);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.throttleHandle);
    window.removeEventListener("resize", this.genLeftValueOfMenu);
  },
  methods: {
    // 生成页面各个模块距离页面顶部的距离
    genModuleTops(idx) {
      const moduleEls = document.querySelectorAll(".module-anchor");
      // this.menus = document.querySelectorAll(".hover-menu");
      // 更新最大滚动距离【防止在mainContent之前还有异步展示的元素】
      this.maxScrollTopBeforeFixed = getTrueTop(this.mainContent);
      const result = [];
      moduleEls.forEach(item => {
        result.push(getTrueTop(item));
      });
      result.reverse();
      this.moduleTops = result;
      this.getMaxScrollTopAfterFixed();
      // 获取菜单悬浮后页面最大可滚动的距离
      this.goAnchor(idx);
      this.dealImagesInContent();
    },
    // 页面滚动到特定标签
    goAnchor(index) {
      this.activeMenuIndex = index === undefined || index === null ? -1 : index;
      window.scrollTo({
        top: this.moduleTops[this.moduleTops.length - 1 - index],
        // top: this.moduleTops[this.moduleTops.length - 1 - index] - 60,
        behavior: "smooth"
      });
      clearTimeout(this.triggerTimer);
      this.triggerScrolling = true;
      this.triggerTimer = setTimeout(() => {
        this.triggerScrolling = false;
      }, 1000);
    },
    // 节流处理页面滚动
    throttleHandle: common.throttle(
      function() {
        this.scrollHandle();
      },
      80,
      { end: true, begin: true }
    ),
    scrollHandle() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.leftMenuFixed = scrollTop > this.maxScrollTopBeforeFixed;
      this.leftMenuAbsoluteBottom = this.shouldFixedAtBottomWhenScroll
        ? scrollTop > this.maxScrollTopAfterFixed
        : false;
      if (this.triggerScrolling) return; // 如果正在通过左侧菜单栏触发滚动，那么不需要再改变左侧菜单栏状态【因为点击的时候已经改变了】
      this.dealMenuActiveStatus(scrollTop);
    },
    // 处理页面滚动时悬浮菜单的选中状态
    dealMenuActiveStatus(scrollTop) {
      const arr = this.moduleTops;
      for (let i = 0, len = arr.length; i < len; i++) {
        if (scrollTop > arr[i]) {
          // if (scrollTop > arr[i] - 60) {
          // 减去顶部组件的高度
          this.activeMenuIndex = len - 1 - i;
          return;
        }
      }
    },
    // 获取左侧浮动菜单悬浮后，页面最大滚动的距离【在达到该滚动距离时菜单悬浮在底部，以防止被底部遮住】
    getMaxScrollTopAfterFixed() {
      const headerH = 0;
      const pageScrollH = document.body.scrollHeight;
      const connectUplusH = document.getElementById("uplus").clientHeight;
      const footerH = document.querySelector(".footer-wrapper").clientHeight;
      const pageClientH = document.body.clientHeight;
      const menuHeight = document.querySelector(".leftmenu-list-wrap")
        .clientHeight;
      const max = pageScrollH - pageClientH;
      const availHeight = pageClientH - headerH - connectUplusH - footerH; // 当页面滚动到最大值后，页面中除了头部、“用心链接，U+服务”、底部组件后可呈现的最大高度【这个时候左侧菜单只有这么大的展示区域了】
      const menuHideHeight = menuHeight - availHeight; // 页面滚动到最大后被遮住掉的菜单高度
      this.footerAndConnectHeight = connectUplusH + footerH;
      this.maxScrollTopAfterFixed = max - menuHideHeight;
    },
    // 生成左侧菜单栏left值
    genLeftValueOfMenu() {
      const { width } = this.mainContent.getBoundingClientRect();
      this.fixedLeft = (document.body.clientWidth - width) / 2;
    },
    // 处理主内容下的图片【都加载完成的时候重新获取左侧菜单栏的相关数据】
    dealImagesInContent() {
      const wrap = document.querySelector(".content-wrap");
      if (!wrap) return;
      const imgs = wrap.querySelectorAll("img");
      if (imgs && imgs.length) {
        this.imgsCountInContent = imgs.length;
        imgs.forEach(item => {
          item.onload = () => {
            this.imgLoadedCount++;
            // 当主内容中的所有图片都加载完成的情况下再重新计算一下页面中的相关尺寸，防止出现左侧菜单栏滚动位置不准确的问题
            if (this.imgLoadedCount === this.imgsCountInContent) {
              this.genModuleTops();
            }
          };
        });
      }
    }
  }
};

function getTrueTop(el) {
  let top = 0;
  let parent = el;
  while (parent) {
    top += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return top;
}



// WEBPACK FOOTER //
// ./src/gtn/views/productSolution/scrollMixin.js